// const axios = require('axios');
import qs from 'qs';
import properties from '../ajio-util/properties';
import { getErrorStatusCode } from '../ajio-util/jsonUtils';
import CONFIG from './config';
import { gtmEventPush } from './GTMdatalayer';



// function uuidv4() {
//   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
//     const r = (Math.random() * 16) | 0;
//     const v = c == 'x' ? r : (r & 0x3) | 0x8;
//     return v.toString(16);
//   });
// }

const getBody = function(params) {
  return params
    .map(function(x) {
      return qs.stringify(x);
    })
    .join('\n');
};

// const tracker = (function() {
//     const APIErrorGAID = properties.getProperty('APIErrorGAID');
//     const uuid = uuidv4();
//     let times = CONFIG.BATCH_COUNT;
//     let params = [];
//     return {
//         trackEvent: (category, action, label) => {
//             const url = CONFIG.BATCH;
//             times--;
//             const obj = {
//                 v: CONFIG.VERSION,
//                 tid: APIErrorGAID,
//                 cid: uuid,
//                 t: CONFIG.TYPE,
//                 ec: category,
//                 ea: action,
//                 el: label
//             }
//             if(!times) {
//                 params.push(obj);
//                 const body = getBody(params);
//                 times = 10;
//                 params = [];
//                 return axios.post(`${url}`, `${body}`)
//             }
//             params.push(obj);
//             return
//         },
//     }
//   })();

export function sendErrorToGA(error, errorMessage) {
  const { url = 'UnkownURL', status } = error;
  let { errors } = errorMessage;
  let flatErrorObject = {
    status
  };
  if (Array.isArray(errors)) {
    errors.map(item => {
      let errorObj = item;
      if (typeof item !== 'object') {
        errorObj = {};
        errorObj.message = JSON.stringify(item);
      }
      flatErrorObject = { ...flatErrorObject, ...errorObj };
    });
  } else if (typeof errors === 'object') {
    flatErrorObject = { ...flatErrorObject, ...errors };
  } else {
    const errorObj = {};
    errors = errors || 'Something went wrong. Try again';
    errorObj.message = JSON.stringify(errors);
    errorObj.type = 'primitiveError';
    flatErrorObject = { ...flatErrorObject, ...errorObj };
  }
  if (!flatErrorObject.message) {
    flatErrorObject = {
      ...flatErrorObject,
      message: 'Sorry !! Currently we are unable reach our server.',
      errorType: 'info'
    };
  }

  const statusCode = getErrorStatusCode(error);
  const eventCategory = 'serviceErrorEvent_ajio';
  const eventAction = url;
  const eventLabel = `${statusCode || 'NoStatusCodeParsed'}: ${flatErrorObject.message}`;

  gaSendEvent(eventCategory, eventAction, eventLabel);
}

export function gaSendEvent(eventCategory, eventAction, eventLabel, status, store, eventName) {
  // AS NOW ELK LOGS are implemented no need to track error on ga to reduce cost
  try {
    gtmEventPush({
      event: eventName || 'service_error',
      eventCategory,
      eventAction,
      eventLabel,
      store_type: store,
      error_status_code: status
    });

   
    
  } catch (error) {
    console.log("Couldn't send to GA: ", error);
  }
}

export function sendErrorInErrorToGA(error, errorInErrorObject) {
  const { url = 'UnknownURL', status } = error;

  const statusCode = getErrorStatusCode(error);
  const eventCategory = 'serviceErrorEvent_ajio';
  const eventAction = url;
  // const eventLabel = `${error.status || "NoStatusCodeParsed"}: ${flatErrorObject.message}`;
  const eventLabel = `${statusCode || '404'}: Oops !! something went wrong. Try after sometime.`;

  gaSendEvent(eventCategory, eventAction, eventLabel);
}
